export const TAG_DISTRIBUTION_CONFIG = {
  CATEGORIES_LIMIT: 1000,
  TAGS_LIMIT: 3000,
  EXCLUDED_CATEGORIES: ['Tier', 'glossary'] as const,
} as const;
